/**
 * The ink tick: a filled, tapered pen stroke (thin start, full at the corner, thin tail). The long stroke runs out
 * past the top-right corner of the box. Drawn by the checkbox, the logo and the day's finishing ring.
 * The shape and its centre line come from the Tudu Paper design system and must not be redrawn.
 */
export const INK_SHAPE =
  'M3.65 14.05 L3.75 14.17 3.85 14.29 3.96 14.40 4.06 14.52 4.17 14.64 4.27 14.76 4.38 14.88 4.49 15.00 4.60 15.12 4.71 15.25 4.82 15.38 4.93 15.50 5.04 15.63 5.15 15.77 5.26 15.90 5.38 16.04 5.49 16.17 5.60 16.31 5.72 16.45 5.83 16.60 5.95 16.74 6.06 16.89 6.18 17.04 6.29 17.19 6.41 17.34 6.53 17.49 6.65 17.65 6.77 17.80 6.89 17.96 7.01 18.12 7.13 18.29 7.25 18.45 7.37 18.62 7.49 18.79 7.61 18.96 7.73 19.13 7.86 19.30 C8.80 20.71 10.10 20.62 10.99 19.17 L 11.10 18.98 11.21 18.80 11.32 18.61 11.43 18.42 11.55 18.23 11.66 18.04 11.78 17.85 11.90 17.65 12.01 17.46 12.13 17.26 12.25 17.06 12.37 16.87 12.50 16.67 12.62 16.46 12.74 16.26 12.87 16.06 13.00 15.86 13.12 15.65 13.25 15.45 13.38 15.24 13.51 15.03 13.65 14.82 13.78 14.61 13.91 14.40 14.05 14.19 14.19 13.98 14.32 13.77 14.46 13.56 14.60 13.35 14.74 13.13 14.88 12.92 15.03 12.71 15.17 12.49 15.32 12.28 15.46 12.06 15.61 11.85 15.76 11.63 15.91 11.42 16.06 11.20 16.21 10.99 16.36 10.77 16.51 10.56 16.67 10.34 16.82 10.12 16.98 9.91 17.14 9.69 17.30 9.48 17.46 9.26 17.62 9.05 17.78 8.83 17.94 8.62 18.11 8.40 18.27 8.19 18.44 7.98 18.60 7.76 18.77 7.55 18.94 7.34 19.11 7.13 19.28 6.92 19.45 6.71 19.63 6.50 19.80 6.29 19.98 6.08 20.15 5.88 20.33 5.67 20.51 5.46 20.69 5.26 20.87 5.06 21.05 4.85 21.23 4.65 21.41 4.45 21.60 4.25 21.78 4.05 21.97 3.86 22.16 3.66 22.35 3.46 22.54 3.27 A0.50 0.50 0 0 0 21.86 2.53 L21.65 2.70 21.44 2.88 21.22 3.06 21.01 3.24 20.80 3.42 20.59 3.60 20.38 3.79 20.17 3.97 19.96 4.16 19.76 4.34 19.55 4.53 19.35 4.72 19.14 4.91 18.94 5.10 18.74 5.30 18.54 5.49 18.34 5.68 18.14 5.88 17.94 6.08 17.75 6.27 17.55 6.47 17.36 6.67 17.16 6.87 16.97 7.07 16.78 7.27 16.59 7.47 16.40 7.67 16.21 7.87 16.03 8.07 15.84 8.28 15.65 8.48 15.47 8.68 15.29 8.89 15.11 9.09 14.93 9.29 14.75 9.50 14.57 9.70 14.39 9.91 14.22 10.11 14.04 10.32 13.87 10.52 13.70 10.73 13.53 10.93 13.36 11.13 13.19 11.34 13.02 11.54 12.86 11.75 12.69 11.95 12.53 12.15 12.37 12.36 12.20 12.56 12.05 12.76 11.89 12.96 11.73 13.16 11.57 13.36 11.42 13.56 11.27 13.76 11.11 13.96 10.96 14.16 10.82 14.36 10.67 14.55 10.52 14.75 10.38 14.94 10.23 15.14 10.09 15.33 9.95 15.52 9.81 15.71 9.67 15.90 9.54 16.09 9.40 16.28 9.27 16.47 9.14 16.65 9.00 16.84 8.88 17.02 8.75 17.20 8.62 17.38 8.50 17.56 8.37 17.74 8.25 17.92 9.38 17.40 10.42 17.79 10.26 17.63 10.11 17.46 9.95 17.30 9.80 17.14 9.65 16.98 9.50 16.82 9.35 16.67 9.20 16.51 9.04 16.36 8.89 16.21 8.75 16.07 8.60 15.92 8.45 15.78 8.30 15.63 8.15 15.49 8.01 15.36 7.86 15.22 7.71 15.09 7.57 14.95 7.42 14.82 7.28 14.69 7.14 14.57 6.99 14.44 6.85 14.32 6.71 14.20 6.57 14.08 6.42 13.97 6.28 13.85 6.14 13.74 6.00 13.63 5.86 13.52 5.72 13.41 5.58 13.31 5.44 13.21 5.31 13.11 5.17 13.01 5.03 12.92 4.89 12.83 4.75 12.75 A0.85 0.85 0 0 0 3.65 14.05 Z';

/** The centre line the ink shape is revealed along. */
export const INK_PATH = 'M4.2 13.4 Q6.6 15.4 9.4 18.9 C12.4 14.2 16.8 7.8 22.2 2.9';

/** The plain tick used by the fill checkbox variant and the Button's success state. */
export const TICK_PATH = 'M5 12.4 9.8 17.2 19.2 6.8';

export function InkTick() {
  return (
    <svg
      className="tp-ink-svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      shapeRendering="geometricPrecision"
    >
      <path className="tp-ink-shape" d={INK_SHAPE} />
    </svg>
  );
}

export function PlainTick() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d={TICK_PATH} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TickSvg({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={TICK_PATH} />
    </svg>
  );
}
